import { render, staticRenderFns } from "./DriverConfirm.vue?vue&type=template&id=1af4bb5c"
import script from "./DriverConfirm.vue?vue&type=script&lang=js"
export * from "./DriverConfirm.vue?vue&type=script&lang=js"
import style0 from "./DriverConfirm.vue?vue&type=style&index=0&id=1af4bb5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports